import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setAppMode } from '@store/global/slice';
import { AppModeEnum } from '@project-types/AppModeEnum';
import { getCurrentLanguageCode } from '@translations/functions';
import { useGetResourcesQuery } from '@api/baseApi';
import { addResourceBundle } from '@translations/functions';



export const useAppLogic = () => {
	const languageCode = getCurrentLanguageCode();
	const dispatch = useDispatch();
	const changeAppMode = (mode: AppModeEnum) => dispatch(setAppMode(mode));

	const { data, isError, isLoading, isFetching } = useGetResourcesQuery({ language: languageCode });

	useEffect(() => {
		if (isError) {
			changeAppMode(AppModeEnum.initDataFailed);
			return;
		}
	}, [ isError ]);

	useEffect(() => {
		if (isLoading || isFetching) {
			changeAppMode(AppModeEnum.initDataStart);
			return;
		}
	}, [ isLoading, isFetching ]);

	useEffect(() => {
		if (data) {
			addResourceBundle(languageCode, data);
			changeAppMode(AppModeEnum.initDataSuccess);
			return;
		}
	}, [ data ]);
}